import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import {
  BrowserView,
  MobileView
} from "react-device-detect";

import videoMP4 from '../assets/bg-d.mp4';
import videoWEBm from '../assets/bg-d.webm';

import face from '../assets/here.jpg';
import bg from '../assets/bg.gif';





class About extends Component {

  state = {
    loading: true
  };

  componentDidMount() {
    document.body.classList.remove('hide');
    setTimeout(() => this.setState({ loading: false }), 500); // simulates loading of data
  }

  
  render() {

    document.body.classList.add('hide');

    const { loading } = this.state;

    if(loading) { 
        return null; 
      }

    return (
    

      <div>
       
       <div className="px-8 md:px-16 xl:px-64 py-12 md:py-32 z-40 relative text-white">
        <Fade>
          <div>
            <h1 className="text-5xl md:text-huge-md xl:text-huge mt-16">Herkko Huttunen</h1>
            Designer + Developer from Jyväskylä, Finland
          </div>
        </Fade>
        <Fade delay={300}>
          <div className="mt-12 md:mt-24 w-full">
            <span className="bg-white inline-block text-black text-xs md:text-base font-heading font-semibold p-3 mr-3 mt-3">UI/UX</span>
            <span className="bg-white inline-block text-black text-xs md:text-base font-heading font-semibold p-3 mr-3 mt-3">Prototyping</span>
            <span className="bg-white inline-block text-black text-xs md:text-base font-heading font-semibold p-3 mr-3 mt-3">Wireframing</span>
            <span className="bg-white inline-block text-black text-xs md:text-base font-heading font-semibold p-3 mr-3 mt-3">Frontend</span>
            <span className="bg-white inline-block text-black text-xs md:text-base font-heading font-semibold p-3 mr-3 mt-3">Design systems</span>
          </div>
        </Fade>
        <Fade  delay={600}>
          <div className="md:flex mt-12 md:mt-24">
            
            <div className="md:w-1/3">
                <h2>Tools</h2>
            </div>
            <div className="md:w-2/3 mt-8 md:mt-0">
              <p>Sketch, Figma, Abstract, Zeplin, InVision, Adobe CC (Illustrator, InDesign, Photoshop, Lightroom, Premiere, After Effects), VS Code, OSX</p>
            </div>

          </div>
          </Fade>
        <Fade>
          <div className="md:flex mt-12 md:mt-24">
            
            <div className="md:w-1/3">
                <h2>Technologies</h2>
            </div>
            <div className="md:w-2/3 mt-8 md:mt-0">
              <p>HTML, CSS (SCSS), JavaScript, PHP, WordPress, Bootstrap, Tailwind CSS, Version control (git), Vue/React (basics), React Native (basics)</p>
            </div>

          </div>
          </Fade>
          <Fade>
          <div className="mt-12 md:mt-24 w-full h-128 bg-cover bg-center" style={ { backgroundImage: 'url(' + face + ')' } }>
          </div>
          </Fade>
          <Fade>
          <div className="md:flex mt-12 md:mt-24 md:-mx-4">
            
            <div className="md:w-1/3 md:mx-4 border-t border-white pt-2">
                <p className="font-bold text-sm">Email</p>
                <h2 className="mt-2 md:mt-6"> <a href="mailto:herkko@erhe.fi" target="_blank" rel="noopener noreferrer" className="text-white no-underline link"><span>herkko@erhe.fi</span></a></h2>
            </div>
            <div className="mt-6 md:mt-0 md:w-1/3 md:mx-4 border-t border-white pt-2">
                <p className="font-bold text-sm">Phone</p>
                <h2 className="mt-2 md:mt-6"> <a href="tel:+358503454252" target="_blank" rel="noopener noreferrer" className="text-white no-underline link"><span>+358 50 345 4252</span></a></h2>
            </div>
            <div className="mt-6 md:mt-0 md:w-1/3 md:mx-4 border-t border-white pt-2">
                <p className="font-bold text-sm">LinkedIN</p>
                <h2 className="mt-2 md:mt-6"><a href="https://www.linkedin.com/in/herkko/" target="_blank" rel="noopener noreferrer" className="text-white no-underline link"><span>/herkko</span></a></h2>
            </div>
           

          </div>
          </Fade>
          
      </div>

      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      </div>
    );
  }
}

export default About;





// WEBPACK FOOTER //
// ./src/pages/About.js